<div class="datetime-picker-container"
    [ngClass]="{ 'invalid-field': dateTimeControl.invalid && (dateTimeControl.touched)}">
    <div>
        <div class="p-inputgroup" attr.style={{properties.style}}>
            <input type="text" pInputText (click)="toggleDateTimePicker()" [formControl]="dateTimeControl"
                style="border-right: 0px;" placeholder="Select Date and Time">
            <span class="p-inputgroup-addon" style="background-color: white; border-left: 0px;right:0">
                <mat-icon (click)="toggleDateTimePicker()"
                    style="font-size: 20px;height: 20px;width: 20px;">calendar_month</mat-icon>
            </span>
        </div>
    </div>

    <div *ngIf="showDateTimePicker" class="datetime-picker-overlay">
        <div class="calendar-header">
            <h4>Select Date</h4>
        </div>
        <p-calendar *ngIf="!properties?.dateRange" [(ngModel)]="selectedDate" [style]="{'width':'100%'}"
            [inputStyle]="{'width':'100%'}" [inline]="true"></p-calendar>
        <p-calendar *ngIf="properties?.dateRange" selectionMode="range" [(ngModel)]="selectedDate"
            [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [inline]="true"></p-calendar>

        <div class="time-picker">
            <div class="time-header">
                <h4>Select Time</h4>
            </div>
            <p-dropdown *ngIf="!properties?.timeRange" [options]="times" [(ngModel)]="selectedTime"
                [style]="{'width':'100%'}" placeholder="Select a time" [filter]="true"></p-dropdown>
            <p-dropdown *ngIf="properties?.timeRange" [options]="times" [(ngModel)]="selectedTime"
                [style]="{'width':'47%', 'margin':'5px'}" placeholder="Select start time" [filter]="true"></p-dropdown>
            <p-dropdown *ngIf="properties?.timeRange" [options]="times" [(ngModel)]="selectedTime2"
                [style]="{'width':'47%', 'margin':'5px'}" placeholder="Select end time" [filter]="true"></p-dropdown>
        </div>

        <div class="actions">
            <app-button [properties]="{name:'Cancel',type:'light'}" (click)="onCancel()"></app-button>
            <app-button [properties]="{name:'Apply',type:'primary'}" (click)="onApply()"></app-button>
        </div>
    </div>
</div>
<div *ngIf="dateTimeControl?.invalid && (dateTimeControl?.touched)" style="color: #dc3545;position: absolute;">
    <div *ngIf="dateTimeControl?.errors?.['required']">{{placeHolder? placeHolder: 'Date'}} is required</div>
    <div *ngIf="dateTimeControl?.errors?.['endDateInvalid']">{{placeHolder}} must be greater than Start Date</div>
</div>